import {
  loginByHash,
  rigister,
  activateUser,
  resetPassword,
  restorePassword,
  loginById,
} from "./api";
import { useMutation, MutationOptions } from "react-query";
import { notify } from "../../system/utils/notification";
import { REGISTRATION_SUCCESS_MESSAGE } from "./constants";
import { _t } from "../Common/components/InjectIntlContext";

export const useLoginById = (options: MutationOptions<any, any>) => {
  return useMutation(loginById, options);
};

export const useLoginByHash = (options: MutationOptions<any, any>) => {
  return useMutation(loginByHash, options);
};

export const useRegister = (options: MutationOptions<any, any> = {}) => {
  const successfullyRegistered = _t("successfully_registered");
  return useMutation(rigister, {
    onSuccess: (data, variables) => {
      if (data.status === REGISTRATION_SUCCESS_MESSAGE) {
        notify("success", successfullyRegistered);
      } else {
        Object.keys(data.data.messages).map((errorKey) => {
          notify("error", data.data.messages[errorKey]);
        });
      }
    },
  });
};

export const useActivateUser = (options: MutationOptions<any, any> = {}) => {
  return useMutation(activateUser, options);
};
export const useResetPassword = (options: MutationOptions<any, any> = {}) => {
  return useMutation(resetPassword, options);
};
export const useRestorePassword = (options: MutationOptions<any, any> = {}) => {
  const checkEmail = _t("Please visit your email and follow the instruction");
  return useMutation(restorePassword, {
    onSuccess: (data, variables) => {
      notify("success", checkEmail);
    },
    onError: (error: any) => {
      notify("error", error.response?.data?.message);
    },
  });
};
